import Layout from '@/layout'

const route = {
  path: '/infrasTructure',
  component: Layout,
  redirect: '/infrasTructure/index',
  alwaysShow: true, // will always show the root menu
  name: 'infrasTructure',
  meta: {
    title: '基建数据报表',
    icon: 'ABR',
    roles: [
      'ad_basic_report'
    ]
  },
  children: [
    {
      path: '/advertisinggroup/index',
      component: () => import('@/views/advertisinggroup/index.vue'),
      name: 'Advertisinggroup',
      meta: {
        title: '投放组',
        icon: 'component',
        roles: [
          'ad_basic_report.group'
        ]
      }
    },
    {
      path: '/bindingrelationship/index',
      component: () => import('@/views/bindingrelationship/index.vue'),
      name: 'Bindingrelationship',
      meta: {
        title: '绑定关系',
        icon: 'component',
        roles: [
          'ad_basic_report.bind'
        ]
      }
    },
    {
      path: '/reportformslist/index',
      component: () => import('@/views/reportformslist/index.vue'),
      name: 'Reportformslist',
      meta: {
        title: '投手基建数据',
        icon: 'component',
        roles: [
          'ad_basic_report.report'
        ]
      }
    }
  ]
}

export default route
